'use client';

import {
  Authenticated,
  AuthLoading,
  Unauthenticated,
  useConvexAuth,
} from 'convex/react';
import { ErrorBoundary } from './ErrorBoundary';
import { useMemo } from 'react';

import AppRouter from '../AppRouter';
import { SignInForm } from '../auth/SignInForm';
import { AppLayout } from './layout/AppLayout';
import { FullPageLoading } from './FullPageLoading';
import { ConvexErrorFallback } from './ConvexErrorFallback';
import { useConvexErrorHandling } from './hooks/useConvexErrorHandling';
import { useThemeSync } from '../hooks/useThemeSync';
import { TaskStoreProvider } from '../providers/TaskStoreProvider';

export const AppContent = () => {
  const { isLoading } = useConvexAuth();
  const { error } = useConvexErrorHandling();
  
  // Sync theme with meta tag
  useThemeSync();

  // Memoize components to prevent unnecessary re-renders
  const fullPageLoading = useMemo(() => <FullPageLoading />, []);
  const signInForm = useMemo(() => <SignInForm />, []);

  if (error) {
    return <ConvexErrorFallback error={error} />;
  }

  if (isLoading) {
    return fullPageLoading;
  }

  return (
    <>
      <AuthLoading>{fullPageLoading}</AuthLoading>
      <Authenticated>
        <TaskStoreProvider>
          <AppLayout>
            <ErrorBoundary>
              <AppRouter />
            </ErrorBoundary>
          </AppLayout>
        </TaskStoreProvider>
      </Authenticated>
      <Unauthenticated>{signInForm}</Unauthenticated>
    </>
  );
};
